"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = exports.setCookie = void 0;
var setCookie = function (key, value, domain, path) {
    document.cookie = key + "=" + (value || "") + "; domain=" + domain + "; " + (!!path && "path=" + path + ";");
};
exports.setCookie = setCookie;
var getCookie = function (key) {
    var cookies = document.cookie.split(";").map(function (cookie) { return cookie.trim(); });
    var target = cookies.find(function (cookie) { return cookie.indexOf(key + "=") === 0; });
    if (!target) {
        return "";
    }
    return JSON.parse(target.split(key + "=").pop() || "");
};
exports.getCookie = getCookie;
